import { render, staticRenderFns } from "./generic_record_loader.vue?vue&type=template&id=06ffac32&scoped=true"
import script from "./generic_record_loader.vue?vue&type=script&lang=js"
export * from "./generic_record_loader.vue?vue&type=script&lang=js"
import style0 from "./generic_record_loader.vue?vue&type=style&index=0&id=06ffac32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffac32",
  null
  
)

export default component.exports